import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
// アプリでパフォーマンスの測定を開始する場合は、関数を渡して
// 結果をログに記録します (例: reportWebVitals(console.log))
// または分析エンドポイントに送信します。詳細については、https://bit.ly/CRA-vitals を参照してください。
reportWebVitals();
